import React from 'react';
import { Stethoscope, Activity, Syringe, Scissors, Home, Heart, Clock, Shield } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Stethoscope size={32} />,
      title: 'Pet Consultation & Diagnosis',
      description: 'Comprehensive health examinations, diagnostic testing, and expert medical advice for all types of pets. Our thorough consultations help identify and address health concerns early.'
    },
    {
      icon: <Activity size={32} />,
      title: 'Emergency & Critical Care',
      description: '24/7 emergency veterinary services for life-threatening situations. Our experienced team is equipped to handle accidents, poisoning, severe injuries, and critical conditions at any hour.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Parvovirus Treatment',
      description: 'Specialized treatment for parvovirus with proven recovery rates. We have successfully treated numerous critical parvo cases, giving pets a second chance at life through expert care and monitoring.'
    },
    {
      icon: <Scissors size={32} />,
      title: 'Grooming Services',
      description: 'Professional pet grooming including bathing, haircuts, nail trimming, and hygiene maintenance. Keep your pets looking and feeling their best with our gentle grooming services.'
    },
    {
      icon: <Home size={32} />,
      title: 'Boarding Facilities',
      description: 'Safe and comfortable boarding for your pets when you travel. Your pets will receive the same care and attention as our own, with regular checkups, meals, and playtime.'
    },
    {
      icon: <Home size={32} />,
      title: 'Home Services',
      description: 'Convenient at-home veterinary care for pet owners who prefer in-home treatment. Perfect for elderly pets, anxious animals, or owners with mobility challenges.'
    },
    {
      icon: <Heart size={32} />,
      title: 'Street Animal Care',
      description: 'Free and low-cost veterinary services for street dogs and cows in need. We believe every animal deserves quality healthcare regardless of their circumstances.'
    },
    {
      icon: <Syringe size={32} />,
      title: 'Vaccinations & Prevention',
      description: 'Complete vaccination programs to protect your pets from common diseases. Regular preventive care including deworming, tick and flea prevention, and health monitoring.'
    }
  ];

  return (
    <div style={{ paddingTop: '5rem' }}>
      {/* Services Hero */}
      <section className="container" style={{ marginTop: '3rem', marginBottom: '4rem', textAlign: 'center' }}>
        <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
          Our Veterinary Services
        </h1>
        <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
          Comprehensive veterinary care for your beloved pets. From routine checkups to emergency treatment, 
          we're here for you 24/7.
        </p>
      </section>

      {/* Services Grid */}
      <section className="container" style={{ marginBottom: '4rem' }}>
        <div className="ai-grid">
          {services.map((service, index) => (
            <div key={index} className="product-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="product-card-title">{service.title}</h3>
              <p className="product-card-description">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Emergency CTA */}
      <section style={{ background: 'var(--accent-wash)', padding: '4rem 1.5rem' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="emergency-banner" style={{ justifyContent: 'center', marginBottom: '1.5rem' }}>
            <Clock size={24} />
            <span style={{ fontSize: '1.2rem', fontWeight: '600' }}>24/7 Emergency Services</span>
          </div>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Need Immediate Help?
          </h2>
          <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
            Our emergency team is available round-the-clock for critical situations.
          </p>
          <a href="tel:+918199981444" className="btn-primary" style={{ fontSize: '1.1rem' }}>
            Call Emergency Line: +91 81999 81444
          </a>
        </div>
      </section>

      {/* Additional Info */}
      <section className="container" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem' }}>
            Why Choose Our Services?
          </h2>
          <div className="body-medium" style={{ color: 'var(--text-body)' }}>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Experienced Care:</strong> Our veterinary team has extensive experience treating a wide range of 
              conditions, from common ailments to rare and critical cases. We stay updated with the latest veterinary 
              medicine practices to ensure your pets receive the best care possible.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Advanced Facilities:</strong> We're equipped with modern diagnostic tools and treatment facilities 
              to provide comprehensive care under one roof. From X-rays to surgical procedures, we have everything 
              needed for accurate diagnosis and effective treatment.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Affordable Pricing:</strong> Quality veterinary care shouldn't break the bank. We offer competitive 
              pricing and special programs for street animal care, making healthcare accessible to all animals in our community.
            </p>
            <p>
              <strong>Proven Track Record:</strong> With a 4.8-star rating from 269 reviews, our commitment to excellence 
              speaks for itself. Pet parents trust us with their most precious companions, and we honor that trust every day.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;